import $http from "../http";
import { baseUrl } from "../url";
const BASEURL = baseUrl.primary + "/v2";
const url = "http://192.168.0.253:3000/mock/11/v2";
const data = {
  getPerformanceData(params) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionPerformance/PerformancePage`,
      params,
    });
  },
  getRecruitmentProgress(params) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionManagement/PositionSchedulePage`,
      params,
    });
  },
  getMyCandidateList(params) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionCandidate/MyCandidatePage`,
      params,
    });
  },
  getTalentsLivenessData() {
    return $http({
      method: "get",
      url: `${BASEURL}/TalentsMamage/LivennessStatistics`,
    });
  },
  getTalentsEducationData() {
    return $http({
      method: "get",
      url: `${BASEURL}/TalentsMamage/TalentCollectByDegrees`,
    });
  },
  getTalentsSexData() {
    return $http({
      method: "get",
      url: `${BASEURL}/TalentsMamage/TalentsCollectBySex`,
    });
  },
  getOperationStatistics(params) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionCandidate/OperationStatistics`,
      params,
    });
  },
  // 首页总览（业绩）
  getPerformancePandect(isDirector) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionPerformance/PerformancePandect?isDirector=${isDirector}`,
    });
  },
  // 首页总览（候选人）
  getCandidatePandect(isDirector) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionCandidate/CandidatePandect?isDirector=${isDirector}`,
    });
  },
  // 首页总览（项目）
  getPositionPandect(isDirector) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionManagement/PositionPandect?isDirector=${isDirector}`,
    });
  },
  // 首页总览（人才库）
  getTalentsPandect(isDirector) {
    return $http({
      method: "get",
      url: `${BASEURL}/TalentsMamage/TalentsPandect?isDirector=${isDirector}`,
    });
  },
  businessStatisticsExport(sendData) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionCandidate/Export?userId=${sendData.userId}&dateType=${sendData.dateType}&data=${sendData.date}`,
      responseType: "blob",
    });
  },
  jobProgressExport(sendData) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionManagement/Export?customerId=${sendData.customerId}&role=${sendData.role}&userId=${sendData.userId}`,
      responseType: "blob",
    });
  },
  attendanceExport(sendData) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/Performance/Export?userId=${sendData.userId}&dateType=${sendData.dateType}`,
      responseType: "blob",
    });
  },
  customerExport(sendData) {
    return $http({
      method: "get",
      url: `${BASEURL}/Customer/CustomerExport?customerName=${sendData.customerName}&isCooperation=${sendData.isCooperation}&customerLevel=${sendData.customerLevel}&industry=${sendData.industry}&city=${sendData.city}&principalId=${sendData.principalId}&keyWord=${sendData.keyWord}`,
      responseType: "blob",
    });
  },
  positiionExport(sendData) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionManagement/PositionExport?position=${sendData.position}&customerId=${sendData.customerId}&startTime=${sendData.startTime}&role=${sendData.role}&userId=${sendData.userId}&workplace=${sendData.workplace}&state=${sendData.state}&keyWord=${sendData.keyWord}`,
      responseType: "blob",
    });
  },
  canditiondateExport(sendData) {
    return $http({
      method: "get",
      url: `${BASEURL}/Position/PositionCandidate/ExportCandidate?positionId=${sendData.positionId}&state=${sendData.state}`,
      responseType: "blob",
    });
  },
  getHistoryAttendanceExport(datetype, userId) {
    return $http({
      method: "get",
      url: `${BASEURL}/Main/Attendance/Export?datetype=${datetype}&userId=${userId}`,
      responseType: "blob",
    });
  },
};

export default data;
